<div class="le-component">
  <div class="le-step-content">
    <div class="le-form-container">

      <div class="le-search-field-content">
        <div class="le-search-field-row">
          <div class="le-search-filter-active-column">
            <div class="mydocma-form">
              <mat-slide-toggle matInput [checked]="(isAssignedAll$ | async)" (toggleChange)="onActiveAllToggled()">
              </mat-slide-toggle>
            </div>
          </div>
          <div class="le-search-filter-search-column">
            <mydocma-search-field [options]="searchOptions">
            </mydocma-search-field>
          </div>
        </div>
      </div>

      <mydocma-grid #grid
                       class="ag-theme-alpine mydocma-ag-grid le-grid"
                       [gridOptions]="gridOptions">
      </mydocma-grid>

    </div>
  </div>
</div>
